import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Select, message } from 'antd';
import { useTranslation } from '../../../i18n';
import { talentList } from '../talentSquare/talentSquareData';

const inviteOptions = [
  { value: 'vn-vitc-sep', label: 'VN 维C精华 · 9月定向' },
  { value: 'vn-beauty-q4', label: 'VN 美妆合集 · Q4 定向' },
  { value: 'sea-new', label: '东南亚新品 · 10月定向' },
];

type TargetInviteModalProps = {
  open: boolean;
  talentIds: string[];
  /** Overrides the title name for a single talent not present in the square data. */
  talentName?: string;
  onClose: () => void;
};

export function TargetInviteModal({ open, talentIds, talentName, onClose }: TargetInviteModalProps) {
  const { t } = useTranslation();
  const [inviteId, setInviteId] = useState(inviteOptions[0].value);

  useEffect(() => {
    if (open) {
      setInviteId(inviteOptions[0].value);
    }
  }, [open]);

  const titleSuffix = useMemo(() => {
    if (talentIds.length === 0) {
      return '';
    }
    if (talentIds.length === 1) {
      const talent = talentList.find((item) => item.id === talentIds[0]);
      return talentName ?? talent?.name ?? talentIds[0];
    }
    return t('invitation.batch_count', { count: talentIds.length });
  }, [talentIds, talentName, t]);

  const submit = () => {
    const label = inviteOptions.find((item) => item.value === inviteId)?.label ?? '';
    message.success(t('invitation.joined', { name: label }));
    onClose();
  };

  const title = titleSuffix
    ? t('invitation.join_title_named', { name: titleSuffix })
    : t('invitation.join_title');

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      destroyOnClose
      centered
      width={480}
      closeIcon={
        <span className="cursor-pointer text-sm font-normal text-slate-500 hover:text-slate-700">
          {t('common.close')}
        </span>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button onClick={onClose}>{t('common.cancel')}</Button>
          <Button
            type="primary"
            className="wb-btn-primary"
            disabled={talentIds.length === 0}
            onClick={submit}
          >
            {t('invitation.add')}
          </Button>
        </div>
      }
    >
      <div>
        <div className="mb-1.5 text-sm font-medium text-slate-700">{t('invitation.invite')}</div>
        <Select
          className="w-full"
          value={inviteId}
          options={inviteOptions}
          onChange={setInviteId}
        />
        <p className="mb-0 mt-3 text-xs leading-relaxed text-slate-400">
          {t('invitation.target_hint')}
        </p>
      </div>
    </Modal>
  );
}
